export default {
    finalize(data) {
        let autoRefresh = data["global"];
        if (autoRefresh["autorefresh"]) {
            let autoRefreshArgs = autoRefresh["autoRefreshArgs"];
            let checkMode = autoRefreshArgs["checkmode"];
            let autoRefreshHash = "";
            let autoRefreshVerbose = autoRefreshArgs["autoRefreshVerbose"];
            let testMode = autoRefreshArgs["testMode"];
            let firstCheck = true;
            // console.log("autoRefresh : on", autoRefreshArgs);
            console.log("autoRefresh : on");
            jQuery(function ($) {
                let $body = $('body');
                if (testMode === "true") {
                    $body.addClass("test");
                } else {
                    $body.removeClass("test");
                }

                function checkfiles(first) {
                    if (testMode === "true") {
                        $body.addClass("test");
                    } else {
                        $body.removeClass("test");
                    }

                    $.ajax({
                        url: autoRefreshArgs["url"], method: "post", data: {'action': 'getHash'},
                        success: function (response) {
                            if (autoRefreshVerbose) {
                                console.log(response);
                            }
                            if (response === "false") {
                                checkMode = false;
                            } else {
                                response = JSON.parse(response);

                                if (first) {
                                    autoRefreshHash = response["content"];
                                    firstCheck = false;
                                }
                                testMode = response["testMode"];
                                // console.log(firstCheck, response["content"], autoRefreshHash, response["content"] !== autoRefreshHash, checkMode == true);

                                if (response["content"] !== autoRefreshHash && checkMode) {
                                    if (autoRefreshVerbose) {
                                        console.log('reload');
                                    }
                                    // window.location.reload();
                                    window.location.reload(true);
                                }
                            }
                        },
                    });

                }

                $(document).ready(function () {

                    setInterval(function () {
                        if (checkMode) {
                            checkfiles(firstCheck);
                        }
                    }, autoRefreshArgs["refreshTime"] * 1);
                });

            });
        }
    },
}



// WEBPACK FOOTER //
// ./scripts/util/autorefresh.js